export const metricsAssignmentDemoData = {
  assignmentName: "Romeo and Juliet Analysis",
  className: "9th Grade A",
  gradedDate: "Feb 5, 2026",
  studentsCount: 2,
  overallAvg: 80,
  studentGroups: {
    high: 1,
    medium: 1,
    low: 0,
  },
  rubricBreakdown: {
    rubric: { id: "rubric-abc123", name: "Essay Rubric" },
    data: [
      {
        criterionId: 1,
        criterionName: "Argument & Thesis",
        avgGrade: 3.5,
        maxGrade: 4,
        label: "Strong",
      },
      {
        criterionId: 2,
        criterionName: "Evidence & Support",
        avgGrade: 3.0,
        maxGrade: 4,
        label: "Growing",
      },
      {
        criterionId: 3,
        criterionName: "Organization & Structure",
        avgGrade: 2.5,
        maxGrade: 4,
        label: "Needs Support",
      },
      {
        criterionId: 4,
        criterionName: "Style & Conventions",
        avgGrade: 3.0,
        maxGrade: 4,
        label: "Growing",
      },
    ],
  },
  scoreDistribution: {
    maxScore: 10,
    totalStudents: 2,
    rows: [
      { score: 0, count: 0, percentage: 0 },
      { score: 1, count: 0, percentage: 0 },
      { score: 2, count: 0, percentage: 0 },
      { score: 3, count: 0, percentage: 0 },
      { score: 4, count: 0, percentage: 0 },
      { score: 5, count: 0, percentage: 0 },
      { score: 6, count: 0, percentage: 0 },
      { score: 7, count: 1, percentage: 50 },
      { score: 8, count: 0, percentage: 0 },
      { score: 9, count: 1, percentage: 50 },
      { score: 10, count: 0, percentage: 0 },
    ],
    mastered: { label: "Strong (≥8)", count: 1, percentage: 50 },
    nonMastered: { label: "Not Strong (<8)", count: 1, percentage: 50 },
  },
  studentPerformance: {
    criteria: [
      { id: 1, name: "Argument & Thesis" },
      { id: 2, name: "Evidence & Support" },
      { id: 3, name: "Organization & Structure" },
      { id: 4, name: "Style & Conventions" },
    ],
    data: [
      {
        essayId: 1,
        studentId: 1,
        name: "Alice Johnson",
        overallScore: 4.0,
        label: "high",
        scores: { 1: 4, 2: 4, 3: 4, 4: 4 },
      },
      {
        essayId: 2,
        studentId: 2,
        name: "Brian Kim",
        overallScore: 3.0,
        label: "medium",
        scores: { 1: 3, 2: 3, 3: 3, 4: 3 },
      },
    ],
    total: 2,
    page: 1,
    limit: 6,
  },
  overallSummary:
    "Overall performance on this Romeo and Juliet analysis was strong, with a class average of 80%. Alice demonstrated excellent textual analysis and argumentation, while Brian showed solid comprehension with room to deepen his critical engagement. Counterargument integration remains the primary area for development across both students.",
  writingBreakdown: {
    strengths: [
      {
        title: "Clear Central Thesis",
        description:
          "Both students stated a clear, arguable position in the opening paragraph with confidence.",
        percentage: 100,
      },
      {
        title: "Formal Academic Tone",
        description:
          "Both students maintained an appropriate academic register with minimal informal language.",
        percentage: 100,
      },
      {
        title: "Textual Evidence",
        description:
          "Alice integrated quotes and scene references effectively. Brian included evidence but with less precision.",
        percentage: 50,
      },
    ],
    needsImprovement: [
      {
        title: "Addressing Counterarguments",
        description:
          "Neither student fully engaged with opposing interpretations of the text.",
        percentage: 100,
      },
      {
        title: "Conclusion Depth",
        description:
          "Both conclusions restated the thesis without synthesizing new insight from the analysis.",
        percentage: 100,
      },
      {
        title: "Paragraph Transitions",
        description:
          "Brian's transitions between body paragraphs felt abrupt in several places.",
        percentage: 50,
      },
    ],
  },
  insightsLessonPlan: [
    {
      type: "persistent_issue",
      title: "Teach Counterargument Integration",
      description:
        "Neither student addressed opposing interpretations of Romeo and Juliet. Try a structured debate where students defend different readings of a scene before writing their analysis.",
    },
    {
      type: "recurring_gap",
      title: "Strengthen Conclusions",
      description:
        "Both essays ended with restatement rather than synthesis. Model a 'so what?' conclusion technique — connecting the literary argument to a broader theme or human experience.",
    },
    {
      type: "build_on",
      title: "Deepen Textual Analysis",
      description:
        "Alice's evidence integration is strong — encourage her to explore secondary critical sources. Brian is ready to move beyond plot summary toward interpretation.",
    },
  ],
  studentGrowthData: [
    { id: 1, firstName: "Alice", lastName: "Johnson", avgGrade: 87 },
    { id: 2, firstName: "Brian", lastName: "Kim", avgGrade: 72 },
  ],
  intervention: {
    students: [{ id: 2, firstName: "Brian", lastName: "Kim" }],
    interventionSynthesis:
      "Brian would benefit from targeted support on evidence analysis and counterargument integration before the next written assignment.",
  },
  extension: {
    students: [{ id: 1, firstName: "Alice", lastName: "Johnson" }],
    extensionSynthesis:
      "Alice is ready for enrichment. Consider assigning a comparative analysis or encouraging her to engage with critical essays about Shakespeare to deepen her literary perspective.",
  },
  reteachPriority: {
    title: "Moving from Plot Summary to Literary Analysis",
    description:
      "Both students show understanding of what happens in Romeo and Juliet, but the analysis stays at the surface level. The next lesson should focus on the difference between describing a scene and interpreting its significance — use a short passage and ask: 'What does Shakespeare want us to understand about love / fate / conflict here?'",
    alsoWatchOutFor:
      "Watch for students quoting the text without explaining the quote's relevance. Also monitor conclusions that simply restate the introduction — prompt students to answer 'so what does this analysis reveal?' to push toward synthesis.",
  },
  celebratePublicly:
    'Formal academic tone and clear thesis statements — the class did an impressive job here. Most essays maintained a professional register and stated their argument clearly from the start. You might say: "Many of you kept your writing clear and focused with strong opening arguments — that kind of formal, confident tone is exactly what makes an essay feel authoritative and well-crafted."',
};

export const metricsAssignmentEmptyData = {
  assignmentName: null,
  className: null,
  gradedDate: null,
  studentsCount: null,
  overallAvg: 0,
  studentGroups: {
    high: 0,
    medium: 0,
    low: 0,
  },
  rubricBreakdown: null,
  scoreDistribution: null,
  studentPerformance: null,
  overallSummary: null,
  writingBreakdown: null,
  insightsLessonPlan: [],
  intervention: null,
  extension: null,
  reteachPriority: null,
  celebratePublicly: null,
};
